import { FormModel } from '@/plugins/ant-design-vue/tsx-support'
import { ThirdWayRequesterType, UserInfos } from '@/api/common/type'

export enum LoginRegisterName {
  /** 账号类型 */
  Account = 'account',
  /** 手机类型 */
  Phone = 'phone',
  /** 邮箱类型 */
  Email = 'email',
  /** 三方类型 <google...> */
  ThirdParty = 'thirdParty'
}
export enum LoginRegisterValue {
  /** 账号类型 */
  Account = 1,
  /** 手机类型 */
  Phone = 2,
  /** 邮箱类型 */
  Email = 3,
  /** 三方类型 <google...> */
  ThirdParty = 4
}

export enum Themes {
  Theme1 = 1,
  Theme2 = 2,
  Theme3 = 3
}

export type RuleAttrName =
  | 'accountRegister'
  | 'phoneRegister'
  | 'emailRegister'
  | 'thirdPartyRegister'

export interface LoginRegisterFromProps {
  showLabel: boolean
  type: LoginRegisterName
  currentPhoneNumberSegment: string
}

export interface ThirdPartyOptions {
  id?: string
  /** 绑定账号时的用户名 */
  platformId?: string
  /** 绑定账号时的用户密码 */
  passwd?: string
  access_token?: string
  /** optional请求方类型：0:APP；1:WAP 一键注册sdk参数 2 facebook 3 Google */
  requester_type?: ThirdWayRequesterType
  mobilePhoneNumber?: string
  email?: string
}

export interface LoginFromProps extends LoginRegisterFromProps {
  test?: boolean
}

export interface RegisterFromProps extends LoginRegisterFromProps {
  thirdPartyOptions?: {
    id?: string
    /** 绑定账号时的用户名 */
    platformId?: string
    /** 绑定账号时的用户密码 */
    passwd?: string
    access_token?: string
    /** optional请求方类型：0:APP；1:WAP 一键注册sdk参数 2 facebook 3 Google */
    requester_type?: ThirdWayRequesterType
    mobilePhoneNumber?: string
    email?: string
  }
  defuForm?: Partial<RegisterFormState>

  /** 账号输入框是否禁用 */
  defaultDisableUsername?: boolean
  /** 密码输入框是否禁用 */
  defaultDisablePassword?: boolean
  /** 密码是否明文 */
  defaultVisiblePassword?: boolean
}

export interface LoginFormState {
  /** 账号 */
  username: string
  /** 密码 */
  userpass: string
  /** 手机号 */
  phone: string
  /** 邮箱地址  */
  email: string
  /** 短信验证码 */
  phoneCode: string
  /** 邮箱验证码 */
  emailCode: string
}

export interface RegisterFormState {
  /** 用户名 */
  platformId: string
  /** 密码 */
  passwd: string
  /** 确认密码 */
  passwdConfirm: string
  /** 手机号码 */
  mobilePhoneNumber: string
  /** 短信验证码 */
  verificationCode: string
  /** 邮箱地址 */
  email: string
  /** 邮箱验证码 */
  emailCode: string
  /** 真实姓名 */
  realName: string
  /** cpf */
  cpfCode: string
  /** 币种 */
  currency: string
  /** 邀请码 */
  inviterId: string
}

export type FormModelAttrs = VueTsxSupport.JSX.ExtractComponentsTsxAttributes<
  typeof FormModel.Tsx,
  unknown
>

export type IRefs = Record<LoginRegisterName, Required<FormModelAttrs>>

export type OnNeedRegister = {
  form: LoginFormState
  registrable: Required<Required<UserInfos>['registrable']>
}

export interface LREvents {
  /** 手机区号变更 */
  onCurrentPhoneNumberSegment: string
  /** 需要短信验证 */
  onVeriryBindPhone: LoginFormState
  /** 登录成功 */
  onLoginSuccess: LoginFormState
  /** 需要注册，跳转到账号设置 */
  onNeedRegister: OnNeedRegister
  /** 注册成功 */
  onRegisterSuccess: RegisterFormState
  /** loading */
  onLoading: boolean
}

export type GeetCaptProps = {
  code?: number
  geetCaptchaId?: string
  forceGeetest?: boolean
}
